export default {
  rencanaBelanjaPage: (state, getters) => {
    return state.rencanaBelanjaPage;
  },
  total: (state, getters) => {
    return state.total;
  },
};
